import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

import { TextIcon } from "../../entities/form-control";

@Component({
	selector: "input-text-icon",
	template: `
		@if (data) {
			<div>
				@if (data.type === "icon") {
					<span class="input-text-icon type-icon" [ngClass]="data.value"> </span>
				}
				@if (data.type === "text") {
					<span class="input-text-icon type-text"> {{ data.value | i18n }} </span>
				}
			</div>
		}
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class InputTextIconComponent {
	@Input() data: TextIcon;
}
